var dot = document.getElementById('dot')
//document.addEventListener("mousemove", getMouse);

if ($('.section--stage').length && '#dot'.length) {
	$('.section--stage').mousemove(function (e) {
		getMouse(e)
	})

	var dotpos = { x: 0, y: 0 }

	setInterval(followMouse, 10)

	var mouse = { x: 0, y: 0 }

	function getMouse(e) {
		mouse.x = e.pageX
		mouse.y = e.pageY
	}

	function followMouse() {
		var distX = mouse.x - dotpos.x
		var distY = mouse.y - dotpos.y

		dotpos.x += distX / 5
		dotpos.y += distY / 2

		dot.style.left = dotpos.x + 'px'
		dot.style.top = dotpos.y + 'px'
	}
}
